/**
 * 某某页面
 * @author: calvin
 * @create: 2017-10-27 10:01
 */

import Vue from 'vue';

const bus = new Vue();

const eventBus = {
    /**
     * 注册全局事件
     * @param {String}   eventName 事件名称
     * @param {Function} handler 事件处理函数
     * @param {Object}   scope vm对象，一般传this
     * @param {Boolean}  once 是否单次注册
     */
    on(eventName, handler, scope = null, once = false) {
        if (once) {
            bus.$once(eventName, handler);
            return;
        }
        bus.$on(eventName, handler);
        if (scope) {
            let originalDestroy = scope.$destroy;
            scope.$destroy = function () {
                bus.$off(eventName, handler);
                originalDestroy.call(this);
            }
        }
    },

    /**
     * 触发事件
     * @param eventName 要触发的事件名称
     * @param data 事件对象
     */
    emit(eventName, data) {
        bus.$emit(eventName, data);
    }
};

export default eventBus;



// WEBPACK FOOTER //
// ./src/utils/eventBus.js